var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M45.536 38.764c-2.013 1.05-12.44 5.337-14.66 6.494s-3.453 1.146-5.207.308-12.85-5.32-14.85-6.276c-1-.478-1.524-.88-1.524-1.26v-3.813s14.447-3.145 16.78-3.982 3.14-.867 5.126-.14 13.853 2.868 15.814 3.587v3.76c0 .377-.452.8-1.477 1.324z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M45.536 28.733c-2.013 1.05-12.44 5.337-14.66 6.494s-3.453 1.146-5.207.308-12.85-5.32-14.85-6.276-2.04-1.613-.077-2.382l15.332-5.935c2.332-.837 3.14-.867 5.126-.14s12.35 4.853 14.312 5.57 2.037 1.31.024 2.36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.884 -9.45)scale(.84833)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#a41e11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d82c20",
    d: "M45.536 34.95c-2.013 1.05-12.44 5.337-14.66 6.494s-3.453 1.146-5.207.308-12.85-5.32-14.85-6.276-2.04-1.613-.077-2.382l15.332-5.936c2.332-.836 3.14-.867 5.126-.14S43.55 31.87 45.51 32.6s2.037 1.31.024 2.36z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: -6.218,
    fill: "#a41e11"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#d82c20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a41e11",
    d: "M45.536 26.098c-2.013 1.05-12.44 5.337-14.66 6.495s-3.453 1.146-5.207.308-12.85-5.32-14.85-6.276c-1-.478-1.524-.88-1.524-1.26V21.55s14.447-3.145 16.78-3.982 3.14-.867 5.126-.14 13.853 2.868 15.814 3.587v3.76c0 .377-.452.8-1.477 1.324z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: -6.449,
    fill: "#d82c20"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.096 20.712-1.182-1.965-3.774-.34 2.816-1.016-.845-1.56 2.636 1.03 2.486-.814-.672 1.612 2.534.95-3.268.34zM22.8 24.624l8.74-1.342-2.64 3.872z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.444,
    cy: 21.402,
    rx: 4.672,
    ry: 1.811
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7a0c00",
    d: "m42.132 21.138-5.17 2.042-.004-4.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad2115",
    d: "m36.963 23.18-.56.22-5.166-2.042 5.723-2.264z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/redis.8d212a46631acf8b1be07d5d205c69a0.svg";
export { ForwardRef as ReactComponent };